import { render, staticRenderFns } from "./AssessmentRedirect.vue?vue&type=template&id=0cbfa3c4"
import script from "./AssessmentRedirect.vue?vue&type=script&lang=js"
export * from "./AssessmentRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports